<template>
  <!-- 绑定邮箱/手机号/弹层 -->
  <div class="bindTips" v-if="state">
    <div class="box" v-show="!isPhone">
      <div class="message-header">
        温馨提示
      </div>
      <div class="message-content">
        该手机号已注册，如仍需绑定请联系在线客服
      </div>
      <div class="message-btn">
        <button class="cancel" @click="isPhone = true">取消</button>
        <button class="action" @click="goUdesk()">联系客服</button>
      </div>
    </div>
    <div class="tipsContent pa bg_fff" @click.stop v-show="isPhone">
      <div class="tipsTitle f_18 color_40 font_w_b">
        <span>{{bindTipsOptions.type==='phone'?'绑定手机号':'绑定邮箱'}}</span>
        <span class="cancel-btn cursor_p" @click="cancelForm()">×</span>
      </div>
      <div class="sub-title">为提升账号安全，请绑定手机号，绑定后可用验证码登录</div>
      <template>
        <div class="form">
          <dl class="formItem flex" :class="[bindTipsError.phone?'errorTips':'']">
            <dt class="f_14 color_60"><span>手机号码</span>：</dt>
            <dd class="flex1">
              <div class="phoneBox flex-c">
                <div class="phoneType text_center f_14 color_60">+86</div>
                <el-input class="restInput noBorder f_14 color_40 flex1" v-model="bindTipsData.phone" placeholder="请输入你的手机号" @focus="inputFocus('phone')" :maxlength="11" ></el-input>
              </div>
              <!-- 错误提示 -->
              <div class="errorTipsDesc f_14" v-if="bindTipsError.phone">
                <span class="iconfont iconinfo"></span>
                <span class="tipsName">{{bindTipsError.phone}}</span>
              </div>
            </dd>
          </dl>
          <dl class="formItem flex" :class="[bindTipsError.code?'errorTips':'']">
            <dt class="f_14 color_60"><span>验证码</span>：</dt>
            <dd class="flex1">
              <div class="codeBox flex-c">
                <el-input class="restInput noBorder f_14 color_40 flex1" v-model="bindTipsData.phone_token" placeholder="请输入验证码" @focus="inputFocus('code')" :maxlength="6" ></el-input>
                <div class="time cursor_p text_center f_14">
                  <span class="color_blue" @click="checkCode('phone')" v-if="bindTipsOptions.time === 60">发送验证码</span>
                  <span class="color_90" v-else >{{bindTipsOptions.time}}s</span>
                </div>
              </div>
              <!-- 错误提示 -->
              <div class="errorTipsDesc f_14" v-if="bindTipsError.code">
                <span class="iconfont iconinfo"></span>
                <span class="tipsName">{{bindTipsError.code}}</span>
              </div>
            </dd>
          </dl>
        </div>
      </template>

      <div class="formButtons clearfix">
        <div class="fr confirm text_center bg_red color_fff f_14 cursor_p" @click="updateInfo()">确定绑定</div>
<!--        <div class="fr cancel text_center color_60 f_14 cursor_p" @click="cancelForm()">取消</div>-->
      </div>
    </div>
  </div>
</template>

<script>
import api from '@/api';
import { get_tUser, dealSignatrue, routerTo, auth, updateJWT } from '@/assets/js/util';

export default {
  name: "BindPhone",
  props: {
    state: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      bindTipsOptions:{
        state:false, //是否显示弹窗
        time:60, //倒计时
        type:'phone', //编辑类型
        getCodeState:false, //是否正在获取验证码
      },
      bindTipsError:{ //弹窗错误提示
        phone:'',
        phone_token:''
      },
      bindTipsData:{ //绑定手机号参数
        phone:'',
        phone_token:''
      },
      isPhone: true,  // 是否显示手机号弹窗
    }
  },
  created() {
    let cv_token = get_tUser().t || ''
    // 获取简历手机号自动填充
    api.account.getUserCvPhone(cv_token).then(res => {
      if (res.code === 1000) {
        if (res.data && res.data.phone) {
          this.bindTipsData.phone = res.data.phone
        }
      }
    })
  },
  methods: {
    // 打开联系客服
    goUdesk() {
      let udesk_container = document.querySelector('#udesk_btn a');
      if(udesk_container != null){
        udesk_container.click();
      }
      this.isPhone = true
    },
    //【bindTips】取消编辑
    cancelForm(){
      this.$emit('close')
    },
    inputFocus(type){
      this.bindTipsError[type] = '';
    },
    //【bindTips】获取验证码 手机号/邮箱
    checkCode(codeType){
      this.bindTipsOptions.type = codeType;
      let { time, state, type, getCodeState, } = this.bindTipsOptions;
      let { phone, phone_token } = this.bindTipsData; //绑定手机号参数
      if(getCodeState){
        return false;
      }
      let formState = true;
      if(!phone){
        this.bindTipsError.phone = '请输入手机号';
        formState = false;
      }else if(!(/^1[|3|4|5|6|7|8|9][0-9]\d{8,11}$/.test(phone)) || phone.length !== 11){
        this.bindTipsError.phone = '请输入正确的手机号';
        formState = false;
      }
      if(!formState){
        return false;
      }
      this.getCode();
    },
    //【手机】获取短信验证码-接口
    getCode(){
      let codeType = this.bindTipsOptions.type;
      let { time, state, type, getCodeState, } = this.bindTipsOptions;
      let { phone, phone_token } = this.bindTipsData; //绑定手机号参数
      if(getCodeState){
        return false;
      }
      this.bindTipsData.getCodeState = true;
      let query = {
        phone_number:phone,
        premise:'cv_account_bind',
        new_code:true
      }
      api.auth.getPhoneCode(query).then(res=>{
        if(res.code === 1000){
          this.$message({
            message: '获取验证码成功',
            type: 'success'
          });
          this.bindTipsOptions.time = 59;
          this.codeTime();
        } else if (res.code === 2002){
          this.isPhone = false;
        } else{
          this.bindTipsData.getCodeState = false;
          this.$message({
            message: res.message,
            type: 'error'
          });
        }
      })
    },
    //倒计时
    codeTime(){
      this.timeName = setInterval(() => {
        if(this.bindTipsOptions.time === 1){
          clearInterval(this.timeName);
          this.bindTipsOptions.time = 60;
          this.bindTipsOptions.getCodeState = false;
          return false;
        }
        this.bindTipsOptions.time = this.bindTipsOptions.time-1;

      }, 1000);
    },
    // 绑定用户信息前的验证 手机号/邮箱
    async updateInfo(){
      let { time, state, type, getCodeState, } = this.bindTipsOptions;
      let { phone, phone_token } = this.bindTipsData; //绑定手机号参数
      let bindErrorText = '';
      let query = {};
      let formState = true;
      if(!phone){
        this.bindTipsError.phone = '请输入手机号';
        bindErrorText = '请输入手机号';
        formState = false;
      }else if(!(/^1[|3|4|5|6|7|8|9][0-9]\d{8,11}$/.test(phone)) || phone.length !== 11){
        this.bindTipsError.phone = '请输入正确的手机号';
        bindErrorText = '请输入正确的手机号';
        formState = false;
      }
      if (!phone_token) {
        this.bindTipsError.code = '请输入验证码';
        bindErrorText = '请输入验证码';
        formState = false;
      } else if(phone_token.length<6){
        this.bindTipsError.code = '请输入正确的验证码';
        bindErrorText = '请输入正确的验证码';
        formState = false;
      }
      if(!formState){
        this.$message({
          message: bindErrorText,
          type: 'error'
        });
        return false;
      }
      query = {
        operation_type:'bind_phone',
        phone_number:phone,
        phone_code:phone_token
      };
      //绑定手机号
      this.updatePhone(query);
    },
    //绑定手机号
    updatePhone(query){
      let user_token = get_tUser().t || '';
      api.auth.update_users_bind_info(query, user_token).then( async res=>{
        if(res.code === 1000){
          this.$message({
            message: '手机号绑定成功',
            type: 'success'
          });
          if (res.data && res.data.jwt) {
            await updateJWT({
              jwt: res.data.jwt,
              jwt_timestamp: res.data.jwt_timestamp
            })
          }
          this.$emit('success')
          //取消弹窗
          // this.cancelForm();
          //重新获取用户绑定信息
          // this.getUsersInfo();
        }else{
          this.bindTipsData.getCodeState = false;
          this.$message({
            message: res.message,
            type: 'error'
          });
        }
      })
    },
  }
}
</script>

<style lang="scss" scoped>
::v-deep .el-input__inner {
  border: none;
}
.bindTips{
  position: fixed;
  left: 0;
  top: 0;
  right: 0;
  bottom: 0;
  background: rgba($color: #000000, $alpha: .4);
  z-index: 9;
  //错误提示样式
  .errorTipsDesc{
    color: #FD5F39;
    line-height: 24px;
    .iconfont{
      position: relative;
      top: 1px;
    }
    // .tipsName{
    //   margin-left: 8px;
    // }
  }
  .box {
    width: 446px;
    height: 180px;
    background: #fff;
    border-radius: 4px;
    z-index: 9;
    position: absolute;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    margin: auto;
    .message-close {
      font-size: 20px;
      color: #404040;
      font-weight: 600;
      float: right;
      cursor: pointer;
    }
    .message-header {
      height: fit-content;
      // border-bottom: 1px solid #E8E8E8;
      font-size: 18px;
      font-weight: 600;
      color: #404040;
      // line-height: 72px;
      padding: 32px 32px 18px 32px;
    }
    .message-content {
      // width: 360px;
      line-height: 24px;
      padding: 0 32px;
      font-size: 14px;
      color: #606060;
      .message-input-main {
        width: 100%;
        height: 40px;
        background: #F9F9F9;
        padding: 0;
        position: relative;
        input {
          width: calc(100% - 100px);
          height: 100%;
          border: none;
          background: transparent;
          padding: 0 18px;
          color: #404040;
        }
        .message-input-length {
          height: 100%;
          line-height: 40px;
          position: absolute;
          top: 0;
          right: 0;
          padding: 0 18px;
        }
      }
      .select-list{
        flex-wrap: wrap;
        //margin-top: 22px;
        .select-item{
          //width: 74px;
          margin-top: 22px;
          height: 20px;
          cursor: pointer;
          //margin-top: 14px;
          padding: 7px 18px;
          border-radius: 2px;
          border: 1px solid #cfcfcf;
          color: #606060;
          line-height: 20px;
          text-align: center;
          margin-right: 16px;
        }
        .select-item.is-active{
          border: 1px solid #ff4f4c;
          color: #ff4f4c;
        }
      }
    }
    .message-btn {
      text-align: right;
      // position: absolute;
      // bottom: 25px;
      // right: 28px;
      padding: 25px 32px 26px 32px;
      display: flex;
      justify-content: flex-end;
      button {
        display: block;
        width: 80px;
        height: 36px;
        border: 1px solid #D9D9D9;
        border-radius: 2px;
        font-size: 14px;
        color: #606060;
        background: #fff;
        &.action {
          background: #FF4F4C;
          border-color: #FF4F4C;
          color: #fff;
        }
        &.cancel.seccess{
          border-color: #FF4F4C;
          color: #FF4F4C;
        }
        &:last-child {
          margin-left: 16px;
        }
      }
    }
  }
  .tipsContent{
    width: 446px;
    padding: 32px 32px;
    box-sizing: border-box;
    border-radius:4px;
    left: 50%;
    top: 50%;
    transform: translate(-50%, -50%);
    .sub-title {
      font-size: 12px;
      margin-top: 14px;
      color: #bcbcbc;
      //font-size: ;
    }
    .tipsTitle{
      line-height: 18px;
      display: flex;
      justify-content: space-between;
      .cancel-btn {
        font-size: 20px;
        color: #bcbcbc;
      }
    }
    .form{
      padding: 30px 0 1px;
      .formItem{
        margin-bottom: 24px;
        &.errorTips{
          margin-bottom: 12px !important;
        }
        &:last-child {
          margin-bottom: 30px;
        }
        dt{
          width: 70px;
          line-height: 40px;
        }
        dd{
          padding-left: 12px;
        }
      }
    }
    .formButtons{
      .confirm{
        width: 102px;
        height: 36px;
        line-height: 36px;
        margin-left: 16px;
        border-radius: 2px;
        background-color: #ff6644;
        color: #fff;
      }
      .cancel{
        width: 82px;
        height: 34px;
        line-height: 34px;
        border: 1px solid #D9D9D9;

      }
    }
    .codeBox,.phoneBox{
      height: 40px;
      border-radius:2px;
      border:1px solid rgba(236,236,236,1);
      .time{
        line-height: 22px;
        height: 22px;
        width: 102px;
        border-left: 1px solid #DCDFE6;
      }
      .phoneType{
        line-height: 22px;
        height: 22px;
        width: 58px;
        border-right: 1px solid #DCDFE6;
      }
    }
  }
}
</style>